mutation CreateCampaignFile($campaignId: ID!) {
    createCampaignFile(campaignId: $campaignId)
}
